module.exports = __webpack_public_path__ + "static/img/marker.4af6c684.png";